import React, { FC } from 'react';
import { Body, Box } from '@edreamsodigeo/prisma-design-system';
import { getPrices } from '../../Itinerary/ResultsItineraryPrice/ResultsItineraryDualPrice';
import { useItinerary } from '../../Itinerary/Provider';
import { RawMoneyComponent } from '../../../../Shared/Money';
import { useTranslation } from '@edreamsodigeo/frontend-core';
import { useAlternativeItineraryLayerActions } from '../../../../../clientState/providers/AlternativeItineraryProvider/AlternativeItineraryLayerProvider';

type UKNoPrimeFareMessageProps = {
  isAlternativeItinerary?: boolean;
};

const UKNoPrimeFareMessage: FC<UKNoPrimeFareMessageProps> = ({
  isAlternativeItinerary = false,
}) => {
  const { t } = useTranslation();
  const { fees } = useItinerary();
  const { noPrimePrice } = getPrices(fees);
  const { showErrorLayer } = useAlternativeItineraryLayerActions();

  return noPrimePrice ? (
    <Box
      onClick={showErrorLayer}
      sx={{
        border: isAlternativeItinerary ? '1px solid #CBCBCB' : 'none',
        borderTop: '1px solid #E6E6E6',
        backgroundColor: !isAlternativeItinerary ? null : 'neutral.20',
        marginTop: '-17px',
        marginLeft: '-16px',
        marginRight: '-16px',
        marginBottom: '-16px',
        position: 'relative',
        paddingLeft: '1x_small',
        paddingTop: '1x_small',
        paddingBottom: '6px',
        borderBottomRightRadius: '6px',
        borderBottomLeftRadius: '6px',
      }}
      data-testid="uk-no-prime-fare-message"
    >
      <Body
        type="small"
        color="neutral.80"
        textAlign="left"
        sx={{
          marginRight: 'base',
        }}
      >
        {t('prime.membership.fares.discovery.full')}{' '}
        <RawMoneyComponent currency={noPrimePrice.currency} size="small">
          {noPrimePrice.amount}
        </RawMoneyComponent>
      </Body>
    </Box>
  ) : null;
};

export default UKNoPrimeFareMessage;
